//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

export function createPatientOverviewConfiguration(dto: Types.CreateUIConfigurationDto, config?: AxiosRequestConfig | undefined): Promise<number> {
    let url_ = getBaseUrl() + "/api/ui-configuration/patient-overview";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCreateUIConfigurationDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreatePatientOverviewConfiguration,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreatePatientOverviewConfiguration?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreatePatientOverviewConfiguration(_response);
    });
}

function processCreatePatientOverviewConfiguration(response: AxiosResponse): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
    
        result200 = resultData200;
    
        return Promise.resolve<number>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<number>(null as any);
}

export function getPatientOverviewConfigurations(config?: AxiosRequestConfig | undefined): Promise<Types.UIConfigurationListDto[]> {
    let url_ = getBaseUrl() + "/api/ui-configuration/patient-overview";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetPatientOverviewConfigurations,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetPatientOverviewConfigurations?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetPatientOverviewConfigurations(_response);
    });
}

function processGetPatientOverviewConfigurations(response: AxiosResponse): Promise<Types.UIConfigurationListDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
              result200 = resultData200.map(item => 
                Types.initUIConfigurationListDto(item)
              );
            }
        return Promise.resolve<Types.UIConfigurationListDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.UIConfigurationListDto[]>(null as any);
}

export function createDashboardConfiguration(dto: Types.CreateUIConfigurationDto, config?: AxiosRequestConfig | undefined): Promise<number> {
    let url_ = getBaseUrl() + "/api/ui-configuration/dashboard";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCreateUIConfigurationDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateDashboardConfiguration,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreateDashboardConfiguration?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateDashboardConfiguration(_response);
    });
}

function processCreateDashboardConfiguration(response: AxiosResponse): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
    
        result200 = resultData200;
    
        return Promise.resolve<number>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<number>(null as any);
}

export function getDashboardConfigurations(config?: AxiosRequestConfig | undefined): Promise<Types.UIConfigurationListDto[]> {
    let url_ = getBaseUrl() + "/api/ui-configuration/dashboard";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetDashboardConfigurations,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetDashboardConfigurations?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetDashboardConfigurations(_response);
    });
}

function processGetDashboardConfigurations(response: AxiosResponse): Promise<Types.UIConfigurationListDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
              result200 = resultData200.map(item => 
                Types.initUIConfigurationListDto(item)
              );
            }
        return Promise.resolve<Types.UIConfigurationListDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.UIConfigurationListDto[]>(null as any);
}

export function editPatientOverviewConfiguration(id: number, dto: Types.EditUIConfigurationDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/ui-configuration/patient-overview/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeEditUIConfigurationDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigEditPatientOverviewConfiguration,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigEditPatientOverviewConfiguration?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processEditPatientOverviewConfiguration(_response);
    });
}

function processEditPatientOverviewConfiguration(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function deletePatientOverviewConfiguration(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/ui-configuration/patient-overview/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigDeletePatientOverviewConfiguration,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigDeletePatientOverviewConfiguration?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processDeletePatientOverviewConfiguration(_response);
    });
}

function processDeletePatientOverviewConfiguration(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function editDashboardConfiguration(id: number, dto: Types.EditUIConfigurationDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/ui-configuration/dashboard/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeEditUIConfigurationDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigEditDashboardConfiguration,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigEditDashboardConfiguration?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processEditDashboardConfiguration(_response);
    });
}

function processEditDashboardConfiguration(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function deleteDashboardConfiguration(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/ui-configuration/dashboard/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigDeleteDashboardConfiguration,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigDeleteDashboardConfiguration?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processDeleteDashboardConfiguration(_response);
    });
}

function processDeleteDashboardConfiguration(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function getConfiguration(id: number, config?: AxiosRequestConfig | undefined): Promise<Types.UIConfigurationDto> {
    let url_ = getBaseUrl() + "/api/ui-configuration/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetConfiguration,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetConfiguration?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetConfiguration(_response);
    });
}

function processGetConfiguration(response: AxiosResponse): Promise<Types.UIConfigurationDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initUIConfigurationDto(resultData200);
        return Promise.resolve<Types.UIConfigurationDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.UIConfigurationDto>(null as any);
}

export function resetDefaultPatientOverviewConfiguration(config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/ui-configuration/patient-overview/reset";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigResetDefaultPatientOverviewConfiguration,
        ...config,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigResetDefaultPatientOverviewConfiguration?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processResetDefaultPatientOverviewConfiguration(_response);
    });
}

function processResetDefaultPatientOverviewConfiguration(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function resetDefaultDashboardConfiguration(config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/ui-configuration/dashboard/reset";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigResetDefaultDashboardConfiguration,
        ...config,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigResetDefaultDashboardConfiguration?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processResetDefaultDashboardConfiguration(_response);
    });
}

function processResetDefaultDashboardConfiguration(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigCreatePatientOverviewConfiguration: Partial<AxiosRequestConfig> | null;
export function getCreatePatientOverviewConfigurationRequestConfig() {
  return _requestConfigCreatePatientOverviewConfiguration;
}
export function setCreatePatientOverviewConfigurationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreatePatientOverviewConfiguration = value;
}
export function patchCreatePatientOverviewConfigurationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreatePatientOverviewConfiguration = patch(_requestConfigCreatePatientOverviewConfiguration ?? {});
}

let _requestConfigGetPatientOverviewConfigurations: Partial<AxiosRequestConfig> | null;
export function getGetPatientOverviewConfigurationsRequestConfig() {
  return _requestConfigGetPatientOverviewConfigurations;
}
export function setGetPatientOverviewConfigurationsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetPatientOverviewConfigurations = value;
}
export function patchGetPatientOverviewConfigurationsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetPatientOverviewConfigurations = patch(_requestConfigGetPatientOverviewConfigurations ?? {});
}

let _requestConfigCreateDashboardConfiguration: Partial<AxiosRequestConfig> | null;
export function getCreateDashboardConfigurationRequestConfig() {
  return _requestConfigCreateDashboardConfiguration;
}
export function setCreateDashboardConfigurationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateDashboardConfiguration = value;
}
export function patchCreateDashboardConfigurationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateDashboardConfiguration = patch(_requestConfigCreateDashboardConfiguration ?? {});
}

let _requestConfigGetDashboardConfigurations: Partial<AxiosRequestConfig> | null;
export function getGetDashboardConfigurationsRequestConfig() {
  return _requestConfigGetDashboardConfigurations;
}
export function setGetDashboardConfigurationsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetDashboardConfigurations = value;
}
export function patchGetDashboardConfigurationsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetDashboardConfigurations = patch(_requestConfigGetDashboardConfigurations ?? {});
}

let _requestConfigEditPatientOverviewConfiguration: Partial<AxiosRequestConfig> | null;
export function getEditPatientOverviewConfigurationRequestConfig() {
  return _requestConfigEditPatientOverviewConfiguration;
}
export function setEditPatientOverviewConfigurationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigEditPatientOverviewConfiguration = value;
}
export function patchEditPatientOverviewConfigurationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigEditPatientOverviewConfiguration = patch(_requestConfigEditPatientOverviewConfiguration ?? {});
}

let _requestConfigDeletePatientOverviewConfiguration: Partial<AxiosRequestConfig> | null;
export function getDeletePatientOverviewConfigurationRequestConfig() {
  return _requestConfigDeletePatientOverviewConfiguration;
}
export function setDeletePatientOverviewConfigurationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigDeletePatientOverviewConfiguration = value;
}
export function patchDeletePatientOverviewConfigurationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigDeletePatientOverviewConfiguration = patch(_requestConfigDeletePatientOverviewConfiguration ?? {});
}

let _requestConfigEditDashboardConfiguration: Partial<AxiosRequestConfig> | null;
export function getEditDashboardConfigurationRequestConfig() {
  return _requestConfigEditDashboardConfiguration;
}
export function setEditDashboardConfigurationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigEditDashboardConfiguration = value;
}
export function patchEditDashboardConfigurationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigEditDashboardConfiguration = patch(_requestConfigEditDashboardConfiguration ?? {});
}

let _requestConfigDeleteDashboardConfiguration: Partial<AxiosRequestConfig> | null;
export function getDeleteDashboardConfigurationRequestConfig() {
  return _requestConfigDeleteDashboardConfiguration;
}
export function setDeleteDashboardConfigurationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigDeleteDashboardConfiguration = value;
}
export function patchDeleteDashboardConfigurationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigDeleteDashboardConfiguration = patch(_requestConfigDeleteDashboardConfiguration ?? {});
}

let _requestConfigGetConfiguration: Partial<AxiosRequestConfig> | null;
export function getGetConfigurationRequestConfig() {
  return _requestConfigGetConfiguration;
}
export function setGetConfigurationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetConfiguration = value;
}
export function patchGetConfigurationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetConfiguration = patch(_requestConfigGetConfiguration ?? {});
}

let _requestConfigResetDefaultPatientOverviewConfiguration: Partial<AxiosRequestConfig> | null;
export function getResetDefaultPatientOverviewConfigurationRequestConfig() {
  return _requestConfigResetDefaultPatientOverviewConfiguration;
}
export function setResetDefaultPatientOverviewConfigurationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigResetDefaultPatientOverviewConfiguration = value;
}
export function patchResetDefaultPatientOverviewConfigurationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigResetDefaultPatientOverviewConfiguration = patch(_requestConfigResetDefaultPatientOverviewConfiguration ?? {});
}

let _requestConfigResetDefaultDashboardConfiguration: Partial<AxiosRequestConfig> | null;
export function getResetDefaultDashboardConfigurationRequestConfig() {
  return _requestConfigResetDefaultDashboardConfiguration;
}
export function setResetDefaultDashboardConfigurationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigResetDefaultDashboardConfiguration = value;
}
export function patchResetDefaultDashboardConfigurationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigResetDefaultDashboardConfiguration = patch(_requestConfigResetDefaultDashboardConfiguration ?? {});
}